
/* retour en haut depuis le footer */
(function(){
  var b=document.querySelector('.f-top'); if(!b) return;
  b.addEventListener('click',function(){
    if(window.__lenis){ window.__lenis.scrollTo(0); }
    else{ window.scrollTo({top:0,behavior:'smooth'}); }
  });
})();
